// extracted by mini-css-extract-plugin
export default {"contactInfo":"ContactInfo_contactInfo__2uIJp","contactInfoData":"ContactInfo_contactInfoData__o6+9v"};